import styled from "styled-components";

export const StyledContainer = styled.div`
    padding: 16px;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    background: ${({ theme }) => theme.primaryBackground};
`;
